export default __webpack_public_path__ + "static/img/collections-men-jackets-bg.8a2d796.jpg";